import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { LeftIcon } from 'foundations-assets';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import MobilePanel from 'marketplace-ui-common/components/mobile/MobilePanel';
import MobilePanelBody from 'marketplace-ui-common/components/mobile/MobilePanelBody';
import MobilePanelHeader from 'marketplace-ui-common/components/mobile/MobilePanelHeader';
import MobilePanelNavItem from 'marketplace-ui-common/components/mobile/MobilePanelNavItem';
import { useFocusTrap } from 'marketplace-ui-common/hooks/useFocusTrap';
import { useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function NavItemTitle({
  title,
  subtitle
}) {
  return /*#__PURE__*/_jsxs("div", {
    children: [title, /*#__PURE__*/_jsx("br", {}), subtitle && /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: subtitle
      })
    })]
  });
}
export default function MobileFilterFieldPanel({
  children,
  header,
  onApply,
  onClose,
  title,
  subtitle
}) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const fieldPanelButtonRef = useRef(null);
  if (!header) header = title;
  useFocusTrap(isPanelOpen);
  useEffect(() => {
    if (fieldPanelButtonRef.current) {
      fieldPanelButtonRef.current.focus();
    }
  }, [isPanelOpen]);
  return /*#__PURE__*/_jsx(MobilePanelNavItem, {
    onClickItem: () => setIsPanelOpen(true),
    title: /*#__PURE__*/_jsx(NavItemTitle, {
      title: title,
      subtitle: subtitle
    }),
    children: /*#__PURE__*/_jsxs(MobilePanel, {
      open: isPanelOpen,
      children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
        itemLeft: /*#__PURE__*/_jsxs(Button, {
          buttonRef: fieldPanelButtonRef,
          padding: "400",
          marginInlineStart: "200",
          use: "transparent",
          onClick: () => {
            setIsPanelOpen(false);
            onClose();
          },
          children: [/*#__PURE__*/_jsx(LeftIcon, {
            color: "do-not-use-calypso",
            size: "600"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.themes.filterPanel.back"
          })]
        }),
        itemRight: /*#__PURE__*/_jsx(Button, {
          marginInlineEnd: "300",
          use: "transparent",
          onClick: () => onApply(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.themes.filterPanel.apply"
          })
        }),
        title: header
      }), /*#__PURE__*/_jsx(View, {
        paddingBlock: "200",
        paddingInline: "600",
        children: /*#__PURE__*/_jsx(MobilePanelBody, {
          children: children
        })
      })]
    })
  });
}